<template>
    <div id="modal-template">
        <transition name="modal">
            <div class="modal-mask" @click="close" v-show="show">
                <div class="modal-container">
                    <slot name="image"></slot>
                    <div id="content">
                        <div class="font-title-normal">
                            <slot name="title"></slot>
                        </div>
                        <div class="font-normal">
                            <slot name="desc"></slot>
                        </div>
                    </div>
                    <slot name="button"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
      props: ['show'],
      methods: {
        close() {
          this.$emit('close');
        }
      }
    }
</script>
